import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tir-pm-search-input-content-line__left-slot"
}
const _hoisted_2 = { class: "tir-pm-search-input-content-line__text" }
const _hoisted_3 = {
  key: 1,
  class: "tir-pm-search-input-content-line__right-slot"
}

import { computed, PropType, useSlots } from "vue";
import { TirPmOptionListItemElement } from "tir-pm-option-list";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmSearchInputContentLine',
  props: {
  /**Дизейбл */
  isDisabled: {
    type: Boolean,
    default: false
  },
},
  setup(__props) {

const props = __props;

const slots = useSlots();
/**
 * Есть ли слот для хедера
 */
const isWithLeftSlot = computed(() => slots && slots.leftSlot && slots.leftSlot());
/**
 * Есть ли слот для правой области
 */
const isWithRightSlot = computed(() => slots && slots.leftSlot && slots.leftSlot());

/**
 * Пропсы
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmOptionListItemElement), {
    "is-hoverable": !__props.isDisabled
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['tir-pm-search-input-content-line', {'is-disabled': __props.isDisabled}])
      }, [
        (isWithLeftSlot.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "leftSlot")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (isWithRightSlot.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "rightSlot")
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 3
  }, 8, ["is-hoverable"]))
}
}

})